import { Injectable } from '@angular/core';
import { Headers, RequestOptions, Http } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
//import {AuthToken} from './authtoken';
import {Header, Album, Photo, Buyer, Paper, Destination, Shipping, ShippingProfile, MailContent } from "./bean";
@Injectable()
export class PhotoService {
	private apiBase: string = "";
	constructor(private http: Http) {
		var appUrlPath = 'egypt';
		//this.apiBase = window.location.protocol + "//" + 
		//window.location.hostname + ":8082/" + appUrlPath;
		//window.location.hostname + "/" + appUrlPath;
		this.papers[0] = new Paper(0, 'Smooth - Optica One', 250);
		this.papers[1] = new Paper(1, 'Textured - Elegance Velve', 250);
		this.shippings[0] = new Shipping(0, 'Singapore Post Air Mail');
		this.shippings[1] = new Shipping(1, 'DHL');
		this.destinations[0] = new Destination(1, 'Thailand', 
			[
				new ShippingProfile(this.shippings[0], 0, '12-22 days'),
				new ShippingProfile(this.shippings[1], 33.74, '7-15 days')
			]
		);
		this.destinations[1] = new Destination(1, 'Taiwan', 
			[
				new ShippingProfile(this.shippings[1], 31.49, '7-15 days')
			]
		);
		this.destinations[2] = new Destination(1, 'United States', 
			[
				new ShippingProfile(this.shippings[0], 0, '12-22 days'),
				new ShippingProfile(this.shippings[1], 34.53, '6-13 days')
			]
		);
		this.buyer.setDestination(this.destinations[0]);
//		this.destinations[0] = new Destination(1, 'Thailand', [0, 1], [0, 33,74], ['12-22 days', '7-15 days']);
//		this.destinations[1] = new Destination(2, 'Taiwan', [1], [31,49], ['7-15 days']);
//		this.destinations[2] = new Destination(3, 'United States', [0, 1], [0, 34.53], ['12-22 days','6-13 days']);
	}

	public view :number = 1;
	public showFilter : boolean = true;

	public currentKeyword: string;
	public currentAlbum: Album;
	public albums: Array<Album>;
	public result: Array<Photo>;
	// public showBuyingForm: boolean= false;
	public buyingPhoto: Photo;
	private buyingPhotoId : number = null;
	private buyingAlbumId: string = null;
	public buyer: Buyer = new Buyer('', '', 1);
	public papers: Array<Paper>  = new Array<Paper>();
	public destinations: Array<Destination> = new Array<Destination>();
	public shippings: Array<Shipping> = new Array<Shipping>();


	public setCurrentView(view: number) : void {
		this.view = view;
	}
	public setBuyingPhotoId(id: number): void{
		this.buyingPhotoId = id;
	}
	public setBuyingAlbumId(id: string): void{
		this.buyingAlbumId = id;
	}
	public getAlbumById(id: string): Album{
		//let a: Album;
		let l : number = this.albums.length;
		for(let i: number = 0; i < l; i++){
			var a : Album = this.albums[i];
			if( a.albumId == id){
				return a;
			}
		}
		return null;
	}

	private listAlbum() : Promise<Array<Album>>{

		return this.http.get(this.apiBase + "/rest/photo/listAlbums")
		.toPromise()
		.then(function(response){
			return response.json() as Array<Album>;
		})
		.catch(this.handleError)
		;
	}
	public setAlbums(): void{

		this.listAlbum().then((albums) => {
			let newAlbum: boolean = false;
			if(this.albums == null){
				newAlbum = true;
			}
			this.albums = albums;
			if(this.buyingAlbumId != null){
				let album = this.getAlbumById(this.buyingAlbumId);
				//this.setBuyingPhotoId(buyingPhotoId);
				this.setCurrentAlbum(album);
			}
			else if(newAlbum && this.albums.length > 0){
				this.setCurrentAlbum(this.albums[0]);
			}


		})
		.catch(this.handleError)
		;
	}
	private apiSendMail(buyerMail: string, subject:string,body:string): Promise<Boolean>{
		let headers = new Headers({ 'Content-Type': 'application/json' });
		let options = new RequestOptions({ headers: headers});
		let mailContent = new MailContent(buyerMail, subject, body);
		return this.http.post(this.apiBase + '/rest/photo/sendMail', mailContent, options)
		.toPromise()
		.then((response) => {
			if(response.text() == ''){
				return null;
			}
			return response.json() as Boolean;
		})
		.catch(this.handleError)
		;
	}
	public sendMail(buyerMail: string, subject:string,body:string){
		this.apiSendMail(buyerMail, subject, body).then((returnValue) => {
			if(returnValue == true){
				alert("Your order has been placed successfully and our sales person will contact you shortly.")
			}
			else{
				alert('Mail sending error. Please check the email format and try again')
			}
//			this.currentAlbum = album;
//			this.result = photos;
		})
		.catch(this.handleError);

	}




	private listPhotos(album: Album): Promise<Array<Photo>>{
		return this.http.get(this.apiBase + "/rest/photo/listPhotos/"
		 + album.albumId)
		.toPromise()
		.then(function(response){
			return response.json() as Array<Photo>;
		})
		.catch(this.handleError);
	}

	private listPhotosByKeyword(keyword: String): Promise<Array<Photo>>{
		if(keyword == null || keyword == ''){
			return null;
			// this.listPhotos(this.currentAlbum);

		}
		return this.http.get(this.apiBase + "/rest/photo/listPhotosByKeyword/"
			+ keyword.replace('/', '_'))
		.toPromise()
		.then(function(response){
//console.dir(response);
			return response.json() as Array<Photo>;
		})
		.catch(this.handleError);
	}

	private listPhotosByAlbumId(albumId: string): Promise<Array<Photo>>{
		return this.http.get(this.apiBase + "/rest/photo/listPhotos/"
		 + albumId)
		.toPromise()
		.then(function(response){
			return response.json() as Array<Photo>;
		})
		.catch(this.handleError);
	}

	private listPhotosByAlbumIdAndPhotoId(albumId: string, photoId:number): Promise<Array<Photo>>{
		return this.http.get(this.apiBase + "/rest/photo/listPhotos/"
		 + albumId + "/" + photoId)
		.toPromise()
		.then(function(response){
			return response.json() as Array<Photo>;
		})
		.catch(this.handleError);
	}


	public setCurrentAlbumByAlbumId(albumId:string){
		return this.listPhotosByAlbumId(albumId)
		.then((photos) => {
			this.currentAlbum = this.getAlbumById(albumId);;
			this.result = photos;
			this.currentKeyword = null;
		})
		.catch(this.handleError);
	}

	public setCurrentAlbumByAlbumIdAndPhotoId(albumId:string, photoId:number){
		return this.listPhotosByAlbumIdAndPhotoId(albumId, photoId)
		.then((photos) => {
			console.log(photos);
			this.currentAlbum = this.getAlbumById(albumId);;
			this.result = photos;
			this.currentKeyword = null;
		})
		.catch(this.handleError);
	}

	
	public setAlbumsWithoutInitPhotos(): void{
		this.listAlbum().then((albums) => {
			this.albums = albums;
		})
	}

	
	public setCurrentAlbum(album: Album){
		this.listPhotos(album).then((photos) => {
			//console.log('who call you');
			this.currentAlbum = album;
			this.result = photos;
			this.currentKeyword = null;
			// if(this.buyingPhotoId != null){
			// 	this.buyingPhoto = this.getPhotoById(this.buyingPhotoId);
			// 	this.showBuyingForm = true;
				
			// }
		})
		.catch(this.handleError);

	}
	public getPhotoById(id: number): Photo{
		let l : number = this.result.length;
		for(var i: number = 0; i < l; i++){
			let p = this.result[i];
			if(id == p.id){
				return p;
			}
		}
		return null;
	}
	public getCurrentKeyword(): string{
		return this.currentKeyword;
	}
	public setCurrentKeyword(): void {
		if(this.currentKeyword == null || this.currentKeyword == ''){
			return;
		}
		this.listPhotosByKeyword(this.currentKeyword)
		.then( (photos) => {
			if(photos != null){

				this.result = photos;
				this.currentAlbum = null;
			}
		})
	}
	public getSmallImageUrl(location : string) : string{
		return this.apiBase + "/zoom/small/" + location;
	}
	private handleError(error: any): Promise<any> {
		return Promise.reject(error.message || error);
	}
// 	public changeCurrentBuyerPaperByName(paperName: string) : void{
// 				//let newLocale: Locale = null;
// 		for(let i = 0; i < this.papers.length; i++){
// 			let l : Paper = this.papers[i];
// 			if(l.name == paperName){
// 				this.buyer.paper = l;
// 				return;
// 			}
// 		}
// 	}

}




// WEBPACK FOOTER //
// ./src/app/service.photo.ts